const t = e => {
  const n = document.createElement("template");
  return e != null && (n.innerHTML = e), n.content;
};
export { t as parse };